import React from "react";

// MUI Components:
import Box from "@mui/material/Box";

// Fragments
import UserLoginView from "../../Fragments/UserLogin/UserLoginView";

function Login() {
    return(
        <Box sx={{
            display:'flex',
            justifyContent:'center',
            alignItems:'center',
            width:'100%',
            height:'100vh'
        }}>
            <Box >
                <UserLoginView></UserLoginView>
            </Box>
        </Box>
        
    )
}
export default Login;